export const appVersions = {
  name: 'App Versions',
  fields: {
    id: 'ID',
    platform: 'Platform',
    latestVersion: 'Latest version',
    minimumVersion: 'Minimum supported version',
    appIdentifier: 'Bundle ID / Package name',
    storeUrl: 'Store URL',
    releaseNotes: 'Release notes',
    enabled: 'Enabled',
    createdAt: 'Created At',
    updatedAt: 'Last updated',
  },
  helpers: {
    latestVersion: 'Users below this version will see an update prompt (e.g. 1.3.0).',
    minimumVersion: 'Users below this version will see a blocking force-update prompt.',
    appIdentifier: 'iOS: bundle identifier (e.g. com.greenwiser.app). Android: package name.',
    storeUrl: 'Direct link to the App Store / Play Store listing.',
    releaseNotes: 'Shown in the update modal. Optional.',
    enabled: 'When off, no update prompt is shown to any user on this platform.',
  },
  errors: {
    invalidSemver: 'Invalid version format. Use e.g. 1.2.3.',
    invalidUrl: 'Must start with http:// or https://',
    minimumExceedsLatest: 'Minimum version cannot be greater than latest version.',
  },
  sections: {
    versions: 'Versions',
    store: 'Store Configuration',
    prompt: 'Update Prompt',
  },
};
